import React, { createContext, useCallback, useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getCitiesList } from '@/services/coloc-api/marketplace';

const useGetCities = () => {
  const fetchCitiesList = useQuery({
    queryKey: ['getCitiesList'],
    queryFn: () => getCitiesList(),
  });

  const getCityDetail = useCallback(
    (id: number) => {
      if (fetchCitiesList?.data?.data) {
        return fetchCitiesList.data.data.find((element) => element.id === id);
      }
      return undefined;
    },
    [fetchCitiesList?.data?.data]
  );

  // Provide a flat array of all cities for UI rendering
  const citiesList = fetchCitiesList?.data?.data || [];

  return {
    fetchCitiesList,
    getCityDetail,
    citiesList,
  };
};

const CitiesListContext = createContext<ReturnType<typeof useGetCities> | undefined>(undefined);

const CitiesListContextProvider = ({ children }: { children: React.ReactNode }) => {
  const hook = useGetCities();
  return <CitiesListContext.Provider value={hook}>{children}</CitiesListContext.Provider>;
};

const useCitiesListContext = () => {
  const context = useContext(CitiesListContext);
  if (context === null || context === undefined) {
    throw new Error('useCitiesListContext must be used within a CitiesListContextProvider');
  }
  return context;
};

export { useCitiesListContext, CitiesListContextProvider };
